import jStat from 'jstat';

import * as base from './base';

const makePdFn = dof => x =>
  jStat.chisquare.pdf(x, dof);

const makeInvFn = dof => alpha =>
  jStat.chisquare.inv(alpha, dof);

const makeCdfFn = dof => cutoff =>
  jStat.chisquare.cdf(cutoff, dof);

const getPds = dof => {
  const xMin = 0;
  const xMax = dof * 3;

  const pdFn = makePdFn(dof);
  return base.getPds(xMin, xMax, pdFn);
};

const getCutoffsByAlpha = (dof, alpha) => {
  const pdFn = makePdFn(dof);
  const invFn = makeInvFn(dof);

  return base.getCutoffsByAlpha(alpha, pdFn, invFn);
};

const getCutoffsByCutoffXValues = (dof, leftCutoffX, rightCutoffX) => {
  const pdFn = makePdFn(dof);

  return base.getCutoffsByCutoffXValues(pdFn, leftCutoffX, rightCutoffX);
};

const getAlphaByCutoffsAndTailType = (dof, leftCutoffValue, rightCutoffValue, tailType) =>
  base.getAlphaByCutoffsAndTailType(makeCdfFn(dof), leftCutoffValue, rightCutoffValue, tailType);

const chisquareDistributionFunctions = {
  getPds: ({ dof }) => getPds(+dof),

  getCutoffsByAlpha: ({ dof }, alpha) => (
    getCutoffsByAlpha(+dof, +alpha)
  ),

  getCutoffsByCutoffXValues: ({ dof }, leftCutoffX, rightCutoffX) => (
    getCutoffsByCutoffXValues(+dof, +leftCutoffX, +rightCutoffX)
  ),

  getAlphaByCutoffsAndTailType: ({ dof }, leftCutoffValue, rightCutoffValue, tailType) => (
    getAlphaByCutoffsAndTailType(+dof, +leftCutoffValue, +rightCutoffValue, tailType)
  )
};

export default chisquareDistributionFunctions;
